<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	// Design system components
	import { Button, ButtonGroup, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { getPVSetupTypes, type PVSetupTypes } from './pv_setup_helper';
	import { PV_SETUP_IMG_FOLDER, pvSetUpWizardItems } from './pv_setup_info_helper';

	export let pvSetupType: PVSetupTypes;

	const onSelect = (value: PVSetupTypes) => {
		pvSetupType = value;
		pvSelectedType = pvSetUpWizardItems.find((item) => item.type === pvSetupType);
	};

	let pvSelectedType = pvSetUpWizardItems.find((item) => item.type === pvSetupType);
</script>

<div class="d-flex justify-content-between align-items-center mt-s mb-s">
	<ButtonGroup aria-label="Button group" class="mb-s">
		{#each getPVSetupTypes() as type}
			<Button
				id="token-pv-types"
				size="m"
				class={pvSetupType == type.title && 'active'}
				on:click={() => onSelect(type.title)}
			>
				{type.translation}
			</Button>
		{/each}
	</ButtonGroup>
</div>
{#if pvSelectedType}
	{@const image = pvSelectedType.images[0]}
	{#each pvSelectedType.bullets as bullet}
		<Text styleType="body-small" class={'mb-m' + (bullet.style ? ' ' + bullet.style : '')}>
			{$format(bullet.key, { default: bullet.default })}
		</Text>
	{/each}
	<div class="d-flex justify-content-center flex-wrap mt-s mb-s">
		<div class="d-flex justify-content-center flex-direction-column">
			<img
				src={PV_SETUP_IMG_FOLDER + image.src + '.png'}
				alt={$format(pvSelectedType.subtitleKey, { default: pvSelectedType.subtitle })}
			/>
		</div>
	</div>
{/if}

<style>
	img {
		max-width: 100%;
	}
</style>
